<template>
	<div class="page-container">
		<div v-if="loading" class="loading">Loading...</div>
		<div v-if="error" class="error-message">{{ error }}</div>
		<div v-if="!loading">
			<div class="user-email">{{ userEmail }}</div>
			<div class="page-header">
				<slot name="header"></slot>
			</div>
			<div class="page-body">
				<slot name="body"></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'RegisteredPageLayout',
	props: {
		loading: {
			type: Boolean,
			required: true
		},
		error: {
			type: String,
			default: ''
		}
	},
	computed: {
		userEmail() {
			return localStorage.getItem('userEmail') || ''
		}
	}
}
</script>

<style>
.page-container {
	padding: 20px;
	max-width: min(1200px, calc(100vw - 40px));
	width: calc(100% - 40px);
	margin: 0 auto;
	background-color: rgba(255, 255, 255, 0.85);
	border-radius: 8px;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	max-height: calc(100vh - 40px);
	overflow-y: auto;
	overflow-x: auto;
	-webkit-overflow-scrolling: touch;
	box-sizing: border-box;
}

.loading {
	font-size: 18px;
	color: #2c3e50;
	text-align: center;
	padding: 40px;
}

.error-message {
	color: #ff4444;
	font-size: 14px;
	background-color: rgba(255, 68, 68, 0.1);
	padding: 10px;
	border-radius: 4px;
	margin: 20px 0;
	text-align: center;
}

.user-email {
	font-size: 14px;
	color: #666;
	margin-bottom: 10px;
	text-align: left;
}

.page-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;
}

.page-body {
	width: 100%;
	margin-bottom: 20px;
	background-color: white;
}

/* Shared navigation styles */
.page-nav {
	display: flex;
	gap: 10px;
	white-space: nowrap;
}

.nav-link {
	padding: 8px 16px;
	border: 1px solid #ddd;
	border-radius: 4px;
	text-decoration: none;
	color: #2c3e50;
	background-color: white;
	transition: all 0.2s;
}

.nav-link.active {
	background-color: #f5f5f5;
}

.nav-link-logout {
	cursor: pointer;
	margin-left: auto;
}

/* Shared table styles */
.generic-table {
	width: 100%;
	border-collapse: collapse;
	margin-bottom: 20px;
	background-color: white;
}

.generic-table th,
.generic-table td {
	padding: 12px;
	text-align: left;
	border-bottom: 1px solid #ddd;
	white-space: pre-wrap;
}

.generic-table th {
	background-color: #f5f5f5;
}

.generic-table-actions {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 4px;
	width: max-content;
}

.generic-table-action-button {
	margin: 2px;
	padding: 6px 12px;
	border: none;
	border-radius: 4px;
	font-size: 14px;
	cursor: pointer;
	white-space: nowrap;
}

</style>

